import React from "react";

const CircularSpinner = ({
  size = "md",
  className = "",
  color = "primary",
}) => {
  const sizeClasses = {
    xs: "w-3 h-3",
    sm: "w-4 h-4",
    md: "w-6 h-6",
    lg: "w-8 h-8",
    xl: "w-12 h-12",
  };

  const borderClasses = {
    xs: "border",
    sm: "border-2",
    md: "border-2",
    lg: "border-3",
    xl: "border-4",
  };

  const getSpinnerContent = () => {
    switch (color) {
      case "primary":
        return (
          <div className="relative">
            <div
              className={`${sizeClasses[size]} ${borderClasses[size]} border-gray-200 rounded-full`}
            ></div>
            <div
              className={`${sizeClasses[size]} ${borderClasses[size]} border-primary-600 border-t-transparent rounded-full animate-spin absolute inset-0`}
              style={{
                background: "linear-gradient(45deg, #b799c8, #a8e6cf)",
                borderImage: "linear-gradient(45deg, #b799c8, #a8e6cf) 1",
              }}
            ></div>
          </div>
        );
      case "gradient":
        return (
          <div className="relative">
            <div
              className={`${sizeClasses[size]} ${borderClasses[size]} border-gray-200 rounded-full`}
            ></div>
            <div
              className={`${sizeClasses[size]} ${borderClasses[size]} border-t-transparent rounded-full animate-spin absolute inset-0`}
              style={{
                background:
                  "conic-gradient(from 0deg, #b799c8, #fbe682, #a8e6cf, #b799c8)",
                WebkitMask:
                  "radial-gradient(circle at center, transparent 30%, black 30%)",
                mask: "radial-gradient(circle at center, transparent 30%, black 30%)",
              }}
            ></div>
          </div>
        );
      case "white":
        return (
          <div
            className={`${sizeClasses[size]} ${borderClasses[size]} border-white border-t-transparent rounded-full animate-spin ${className}`}
          />
        );
      case "gray":
        return (
          <div
            className={`${sizeClasses[size]} ${borderClasses[size]} border-gray-600 border-t-transparent rounded-full animate-spin ${className}`}
          />
        );
      case "blue":
        return (
          <div
            className={`${sizeClasses[size]} ${borderClasses[size]} border-blue-600 border-t-transparent rounded-full animate-spin ${className}`}
          />
        );
      case "green":
        return (
          <div
            className={`${sizeClasses[size]} ${borderClasses[size]} border-green-600 border-t-transparent rounded-full animate-spin ${className}`}
          />
        );
      default:
        return (
          <div
            className={`${sizeClasses[size]} ${borderClasses[size]} border-primary-600 border-t-transparent rounded-full animate-spin ${className}`}
          />
        );
    }
  };

  return getSpinnerContent();
};

export default CircularSpinner;
